import React from 'react';
import * as THREE from 'three';
import { invalidate } from '@react-three/fiber';
import { cadToThreeJsPosition } from '../scene-utils';
import {
  getBulkImportSolidsSceneState,
  subscribeToBulkImportSolidsSceneState
} from './bulkImportSolidsSceneState';

interface BulkImportSpoolClickMarkerProps {
  offset: THREE.Vector3;
  scale: number;
}

const BulkImportSpoolClickMarker = ({ offset, scale }: BulkImportSpoolClickMarkerProps) => {
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const { spoolClickInfo } = getBulkImportSolidsSceneState();

  const worldPosition = React.useMemo(() => {
    if (!spoolClickInfo?.clickPoint) return null;
    const threePos = cadToThreeJsPosition(spoolClickInfo.clickPoint);
    return new THREE.Vector3(
      (threePos.x + offset.x) * scale,
      (threePos.y + offset.y) * scale,
      (threePos.z + offset.z) * scale,
    );
  }, [spoolClickInfo, offset, scale]);

  React.useEffect(() => {
    const unsubscribe = subscribeToBulkImportSolidsSceneState(() => {
      forceUpdate();
      invalidate();
    });
    return unsubscribe;
  }, []);

  if (!worldPosition) return null;

  return (
    <group position={worldPosition}>
      <mesh>
        <sphereGeometry args={[1.5, 16, 16]} />
        <meshStandardMaterial color="#00cc00" />
      </mesh>
    </group>
  );
};

export default BulkImportSpoolClickMarker;
